const getBaseUrl = () => {
  if (window?.location?.origin) {
    var base_url = window.location.origin

    var apiUrl = `${base_url}/home2026-api`
    return apiUrl
  } else {
    return ''
  }
}

const getTemplate = () => {
  if (window?.location?.origin) {
    var base_url = window.location.origin

    var apiUrl = `${base_url}/home2026-api/public/template/home2026_user_template.xlsx`
    return apiUrl
  } else {
    return ''
  }
}

const getTemplateAdmin = () => {
  if (window?.location?.origin) {
    var base_url = window.location.origin

    var apiUrl = `${base_url}/home2026-api/public/template/home2026_admin_bypass_template.xlsx`
    return apiUrl
  } else {
    return ''
  }
}

const appConfig = {
  pathUserTemplate: 'https://home2026-api.event-ku.com/public/template/home2026_user_template.xlsx',
  //pathUserTemplate: getTemplate(),
  //pathUserTemplateAdmin: getTemplateAdmin(),
  pathCodeTemplate: '',
  apiPrefix: 'https://home2026-api.event-ku.com',
  //apiPrefix: getBaseUrl(),
  authenticatedEntryPath: '/admin-eventqiu/user',
  unAuthenticatedEntryPath: '/admin-eventqiu/sign-in',
  adminPath: '/admin-eventqiu',
  tourPath: '/',
  notFound: '/not-found',
  locale: 'en',
  enableMock: false,
}

export default appConfig
